import React from "react";

import { BarChart } from "./";
import { getRgbaColors } from "@util/colors";

export default function GlaucomaDiagnosis({ data }) {
  if (!data) return null;

  const formattedData = {
    labels: data.diagnoses.map((m) => m.diagnosis),
    datasets: [
      {
        data: data.diagnoses.map((m) => m.count),
        backgroundColor: getRgbaColors(12),
      },
    ],
  };

  return <BarChart data={formattedData} />;
}
